import React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import "./Loader.css";
import CircularProgress, {
  circularProgressClasses,
} from '@mui/material/CircularProgress';

const LoaderComponent = (props) => {
    return ( 
     <div className='loader-cntnr' >
           <Box sx={{ position: 'relative' }}>
        <CircularProgress
          variant="determinate"
          sx={{
            color: (theme) =>
              theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
          }}
          size={40}
          thickness={2}
          {...props}
          value={100}
        />
        <CircularProgress
          variant="indeterminate"
          disableShrink
          sx={{
            color: (theme) => (theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'),
            animationDuration: '550ms',
            position: 'absolute',
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: 'round',
            },
          }}
          size={40}
          thickness={2}
        //   {...props}
        />
      </Box>
     </div>
     );
}
 
export default LoaderComponent;